import BorderButton from '@/Component/Common/Forms/BorderButton';
import PrimaryButton from '@/Component/Common/Forms/PrimaryButton';
import Modal from '@/Component/Common/Modal';
import { LoaderSVG } from '@/Component/Common/SVGs/CommonSVG';
import { ChangeInfluencerStatusAPI, SelfAPI } from '@/Utils/APIRequest/Endpoints';
import { CustomToast } from '@/Utils/CustomToast';
import usePost from '@/Utils/Hooks/usePost';
import { useRouter } from 'next/navigation';

const BankModal = (props) => {
    const { bankModalOpen, setBankModalOpen, setOpenSideModal } = props;
    const router = useRouter();

    const handleUpdate = () => {
        setOpenSideModal(null);
        setBankModalOpen((prev) => prev !== bankModalOpen)
        router.push('/influencer/profile/bank-account');
    }

    return (
        <Modal modalSize="w-96 max-w-4/5" modal={bankModalOpen} setModal={setBankModalOpen}>
            <div className="flex flex-col items-center gap-8 py-3">
                <h5 className="text-xl font-medium text-center">To complete this campaign and receive payment, please add your bank details first.</h5>
                <div className="flex justify-center *:flex-1 gap-1.5 w-full">
                    <BorderButton onClick={() => setBankModalOpen((prev) => prev !== bankModalOpen)} customClass='!w-full '>Cancel</BorderButton>
                    <PrimaryButton onClick={handleUpdate} customClass='!w-full flex items-center justify-center gap-1.5'>
                        Add Bank Details
                    </PrimaryButton>
                </div>
            </div>
        </Modal>
    )
}

export default BankModal
